import React from "react";

export default function Mensaje271195() {
  return (
    <>
      <p>
        <h6>27 DE NOVIEMBRE DE 1995</h6>
        <br />
        <p>
          Voy a tratar de explicar con palabras lo que Dios comunicó a mi alma
          sin palabras. <br />
          <br />
          Después de comulgar con el Cuerpo y Sangre de Jesús. El inmenso AMOR
          DE DIOS me invadió. Este inmenso AMOR llegó a mi alma en profundo
          silencio. El permaneció en mi y sin palabras le manifestó a mi corazón
          que este infinito AMOR de Dios y por su medio en nosotros, los que lo
          recibimos en la Santa Comunión, en su infinita Misericordia se
          comunica a todas las almas, aún a las que no lo reciben. Para
          llamarlas y darles vida, con su inmenso AMOR presente en la SAGRADA
          EUCARISTIA. <br />
          <br />
          Y EL AMOR me dice, ora así: <br />
          <br />
          ¡Oh! amor infinito que nunca cesas de llamar <br />
          ¡Oh! Pasión infinita que nunca dejas de padecer <br />
          Tú llamas <br />
          Tú padeces <br />
          y amas las almas <br />
          porque almas de tu Alma son <br />
          Amén.
        </p>
      </p>
    </>
  );
}
